import { getEntitySubdomain } from '@opengov/app-core/entity';
import { composeEffects } from '@opengov/compose-app/core/module';
import { createStructuredSelector } from '@opengov/compose-app/reselect';
import { getStandardTemplate, getStandardTemplates, hydrateStandardTemplate } from '@opengov/api-deprecated';
import { IHydrationContext, IReportTemplate } from '@opengov/reporting-types';

import { reportTemplateActionCreators } from './reportTemplateState';

export const reportTemplateEffects = composeEffects('report-templates', (compose) => ({
  getReportTemplates: compose.statefulPayloadlessEffect(
    createStructuredSelector({
      requestedEntitySubdomain: getEntitySubdomain
    }),
    async ({ requestedEntitySubdomain }) => {
      reportTemplateActionCreators.loadReportTemplatesRequest();

      return getStandardTemplates({ requestedEntitySubdomain })
        .then((payload: { templates: IReportTemplate[] }) => {
          reportTemplateActionCreators.loadReportTemplatesSuccess(payload);
          return payload;
        })
        .catch(reportTemplateActionCreators.loadReportTemplatesFailure);
    }
  ),
  getTemplate: compose.statefulEffect(
    createStructuredSelector({
      requestedEntitySubdomain: getEntitySubdomain
    }),
    async ({ requestedEntitySubdomain }, e: { id: string }): Promise<IReportTemplate> =>
      getStandardTemplate({ requestedEntitySubdomain, templateId: e.id })
  ),
  hydrateTemplate: compose.statefulEffect(
    createStructuredSelector({
      requestedEntitySubdomain: getEntitySubdomain
    }),
    async (
      { requestedEntitySubdomain },
      e: { templateId: string; context: IHydrationContext }
    ): Promise<IReportTemplate> =>
      hydrateStandardTemplate({ requestedEntitySubdomain, templateId: e.templateId }, e.context)
  )
}));
